var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiUpgradeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5773 37.848H26.1435C25.613 37.848 25.1802 37.4153 25.1802 36.8847V36.4526C25.1802 31.4345 20 30.0249 20 23.2811C20 17.0937 25.1801 14 30.3604 14C35.5407 14 40.7207 17.0937 40.7207 23.2811C40.7207 30.0249 35.5405 31.4345 35.5405 36.4526V36.8847C35.5405 37.4153 35.1078 37.848 34.5773 37.848H34.5773Z",
    fill: "#6C7DE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9589 41.3555C25.4735 41.3555 25.08 40.962 25.08 40.4766C25.08 39.9911 25.4734 39.5977 25.9589 39.5977H34.0392C34.5245 39.5977 34.9181 39.9911 34.9181 40.4766C34.9181 40.962 34.5246 41.3555 34.0392 41.3555H25.9589Z",
    fill: "#56D8C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8633 44.3164C27.3779 44.3164 26.9844 43.9229 26.9844 43.4375C26.9844 42.9521 27.3778 42.5586 27.8633 42.5586H32.138C32.6234 42.5586 33.0169 42.9521 33.0169 43.4375C33.0169 43.9229 32.6234 44.3164 32.138 44.3164H30.8795V44.6413C30.8795 45.1267 30.4861 45.5202 30.0006 45.5202C29.5152 45.5202 29.1217 45.1268 29.1217 44.6413V44.3164H27.8633Z",
    fill: "#56D8C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4395 27.7734H31.1973V37.9653H29.4395V27.7734Z",
    fill: "#56D8C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3178 28.6356C31.5979 28.6356 32.6356 27.5979 32.6356 26.3178C32.6356 25.0377 31.5979 24 30.3178 24C29.0377 24 28 25.0377 28 26.3178C28 27.5979 29.0377 28.6356 30.3178 28.6356Z",
    fill: "#56D8C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1719 23.4807C46.6572 23.4807 47.0508 23.8741 47.0508 24.3596C47.0508 24.845 46.6573 25.2385 46.1719 25.2385H44.262C43.7767 25.2385 43.3831 24.845 43.3831 24.3596C43.3831 23.8741 43.7766 23.4807 44.262 23.4807H46.1719ZM13.8281 25.2385C13.3428 25.2385 12.9492 24.845 12.9492 24.3596C12.9492 23.8741 13.3427 23.4807 13.8281 23.4807H15.738C16.2233 23.4807 16.6169 23.8741 16.6169 24.3596C16.6169 24.845 16.2234 25.2385 15.738 25.2385H13.8281ZM15.3821 17.6787C14.963 17.436 14.8201 16.8995 15.0628 16.4805C15.3055 16.0614 15.8419 15.9185 16.261 16.1612L17.9149 17.1161C18.334 17.3588 18.4769 17.8953 18.2342 18.3143C17.9915 18.7333 17.4551 18.8762 17.036 18.6336L15.3821 17.6787ZM16.2576 32.558C15.8385 32.7988 15.3036 32.6543 15.0628 32.2353C14.822 31.8163 14.9665 31.2813 15.3855 31.0405L17.0395 30.0856C17.4585 29.8448 17.9934 29.9893 18.2343 30.4083C18.475 30.8274 18.3306 31.3623 17.9115 31.6031L16.2576 32.558ZM44.6178 31.0406C45.0369 31.2833 45.1798 31.8198 44.9371 32.2388C44.6944 32.6579 44.158 32.8008 43.7389 32.5581L42.085 31.6032C41.666 31.3604 41.5231 30.824 41.7657 30.405C42.0085 29.9859 42.5449 29.843 42.9639 30.0857L44.6178 31.0406ZM43.7424 16.1613C44.1614 15.9205 44.6963 16.0649 44.9371 16.484C45.1779 16.9031 45.0334 17.4379 44.6144 17.6788L42.9604 18.6337C42.5414 18.8745 42.0065 18.73 41.7657 18.3109C41.5249 17.8919 41.6693 17.357 42.0884 17.1162L43.7424 16.1613Z",
    fill: "#6C7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiUpgradeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_upgrade_icon.d72ef94885d3f6ca905f4aebc4da4370.svg";